module.exports = __webpack_public_path__ + "img/jaune-6.b9537fe4.png";